import { defineStore } from 'pinia'

export const useCollapseStore = defineStore({
    id: 'collapse',

    state () {
        return {
            collapsed: []
        }
    },

    getters: {
        open (state) {
            return (id) => {
                let index = state.collapsed.findIndex(o => o.id == id);
                return index >= 0;
            }
        }
    },

    actions: {
        add (id) {
            let index = this.collapsed.findIndex(o => o.id == id);
            if (index < 0) this.collapsed.push({id});
        },

        remove (id) {
            let index = this.collapsed.findIndex(o => o.id == id);
            if (index >= 0) this.collapsed.splice(index, 1);
        },

        toggle (id) {
            let index = this.collapsed.findIndex(o => o.id == id);

            if (index < 0) this.collapsed.push({id});
            else this.collapsed.splice(index, 1);
        },

        handleGroup (payload) {
            let elements = this.collapsed.filter(o => {
                return o.group == payload.group && o.id != payload.id
            });

            // Remove each with same group
            elements.forEach(el => {
               this.remove(el.id);
            });

            // add group to current
            let index = this.collapsed.findIndex(o => o.id == payload.id);
            if (index >= 0) this.collapsed[index].group = payload.group;
        }
    }
})
